// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sessionId: __t.u64().primaryKey().name("session_id"),
  gameId: __t.u64().name("game_id"),
  worldId: __t.u64().name("world_id"),
  state: __t.string(),
  startedAt: __t.timestamp().name("started_at"),
  endedAt: __t.timestamp().name("ended_at"),
});
